import React, { Suspense } from "react";
import {
  Col, Container, Row, Card, CardBody, Table, UncontrolledTooltip
} from 'reactstrap';
import Slider from 'react-slide-out';
import FormComponent from "../form";
import SendMessageForm from "../formSendMessage";
import AddTags from "../formAddTags";
import UserStatus from "../UserStatus";
// import UserProducts from "../UserProducts";
import UsersFilter from "../filters";
import 'react-slide-out/lib/index.css';
import * as env from "../../../../env";
import { columnHeader } from "../usersConfig";
import UserActions from "../Actions";
import * as userAction from '../../redux/actions/user';
import Pagination from "../../../../shared/components/pagination/Pagination";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";
import TimeSince from "../../../../shared/TimeSince";
import AdditionalTools  from "../AdditionalTools";
import ReactTags from "react-tag-autocomplete";
import * as users from "../../../../shared/service/users";
import * as validate from "../../../../shared/validate";
import ShieldCheckIcon from "mdi-react/ShieldCheckIcon";
import UserTags from "./EditCell/UserTags";
import * as CurrencyFormat from "react-currency-format";

const UserProducts = React.lazy(() => import("../UserProducts"));
const UserAuthorizedIps = React.lazy(() => import("../UserAuthorizedIps"));


class UsersCommon extends React.Component {
  state = {
    isOpen: false,
    isOpenTags: false,
    isOpenAlert: false,
    isOpenAlertType: 'email',
    usersData : [],
    items: [],
    columnHeader: columnHeader,
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    filters: [],
    curFilters: [],
    userPagination: {
      pageSize: env.RECORDS_PER_PAGE,
      currentPage: 1
    },
    records: 0,
    loading: false,
    use_cases: [],
    use_cases_suggestions: [],
    lead_scores: [],
    lead_scores_suggestions: [],

    lead_stages: [],
    lead_stages_suggestions: [],

    account_managers: [],
    account_managers_suggestions: [],

    formValues: {
      first_name: '',
      last_name: '',
      company: '',
      email: ''
    },
    show: false,
    filtersUpdated: false,

    tags: [],
    userTags: [],

    checkedall: false,
    options: [{name: 'Option 1', id: 1},{name: 'Option 2', id: 2}]
  };

  addTags = () => {
    this.setState({ isOpenTags: true });
  }

  toggleAddNewUser = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  toggleEdit = (editable) => {
    this.setState({editable});
    this.setState(prevState => ({ isOpen: !prevState.isOpen}));
  }

  toggleMessage = (editable, type) => {
    this.setState({editable});
    this.setState({isOpenAlert: true, isOpenAlertType: type});
  }
  
  sendMessage = () => {

    if (this.state.formValues.content === undefined || this.state.formValues.content.trim() === '') {
      this.setState({
        show: true,
        errors: ['Please specify content'],
        success: [],
      });
    } else {
      users.sendAlert({
        sms: (this.state.isOpenAlertType === 'sms') ? 1 : 0,
        email: (this.state.isOpenAlertType === 'email') ? 1 : 0,
        content: this.state.formValues.content,
        uid: this.state.formValues.customerId  
      }).then(response => {
        if (response._user_message_type === 'success') {
          this.setState({
            show: true,
            isOpenAlert: false,
            errors: [],
            success: response._user_message,
          });
        } else {
          this.setState({
            show: true,
            isOpenAlert: false,
            errors: [response._user_message],
            success: '',
          });
        }
      })
    }
  }

  filterUsers = (filters) => {

    let curFilters = [];

    if (filters.key !== undefined && filters.key !== '') {
      this.setState({key: filters.key})
    }

    if (filters.tags !== undefined && filters.tags !== '') {
      curFilters.tags = filters.tags;
    }

    let min_bandwidth = '';
    let max_bandwidth = '';
    let min_proxies = '';
    let max_proxies = '';
    let min_credits = '';
    let max_credits = '';

    if (filters.min_bandwidth !== undefined && filters.min_bandwidth !== '') {
      min_bandwidth = filters.min_bandwidth;
    }

    if (filters.max_bandwidth !== undefined && filters.max_bandwidth !== '') {
      max_bandwidth = filters.max_bandwidth;
    }

    if (filters.min_credits !== undefined && filters.min_credits !== '') {
      min_credits = filters.min_credits;
    }

    if (filters.max_credits !== undefined && filters.max_credits !== '') {
      max_credits = filters.max_credits;
    }

    if (filters.min_proxies !== undefined && filters.min_proxies !== '') {
      min_proxies = filters.min_proxies;
    }

    if (filters.max_proxies !== undefined && filters.max_proxies !== '') {
      max_proxies = filters.max_proxies;
    }

    let signup = [];
    signup['from']  = '';
    signup['to']    = '';

    if (typeof filters.startDate !== undefined && typeof filters.startDate.format !== 'undefined') {
      signup['from'] = filters.startDate.format('YYYY/MM/DD');
    }
   
    if (typeof filters.endDate !== undefined && typeof filters.endDate.format !== 'undefined') {
      signup['to'] = filters.endDate.format('YYYY/MM/DD');
    }

    this.setState({
      signup: {from: signup['from'], to: signup['to']},
      bandwidth: {min: min_bandwidth, max: max_bandwidth},
      proxies: {min: min_proxies, max: max_proxies},
      credits: {min: min_credits, max: max_credits}
    });

    curFilters.status = [];
    curFilters.verificationStatus = [];

    curFilters.type = this.props.type;

    if (this.props.verificationStatus !== undefined) {
      curFilters.verificationStatus.push(this.props.verificationStatus);
    } else if (this.props.type === 'all' || this.props.type === 'Recent_Signups') {
      filters.statuses.forEach(obj => {
        if (obj.checked === true) {
          curFilters.status.push(obj.key);
        } 
      });
    } else {
      curFilters.status.push(this.props.type);
    }

    if (this.props.verificationStatus !== undefined) {
      filters.verificationStatus.forEach(obj => {
        if (obj.checked === true) {
          curFilters.verificationStatus.push(obj.key);
        } 
      });
    }

    curFilters.productTypes = [];

    filters.productTypes.forEach(obj => {
      if (obj.checked === true) {
        curFilters.productTypes.push(obj.key);
      } 
    });

    curFilters.accountTypes = [];

    filters.accountTypes.forEach(obj => {
      if (obj.checked === true) {
        curFilters.accountTypes.push(obj.key);
      } 
    });

    curFilters.sources = [];

    filters.sources.forEach(obj => {
      if (obj.checked === true) {
        curFilters.sources.push(obj.key);
      } 
    });

    curFilters.domains = [];

    filters.domains.forEach(obj => {
      if (obj.checked === true) {
        curFilters.domains.push(obj.url);
      } 
    });

    curFilters.onboardingStatus = [];

    filters.onboardingStatus.forEach(obj => {
      if (obj.checked !== undefined && obj.checked === true) {
        curFilters.onboardingStatus.push(obj.value);
      }
    });

    this.setState({startIndex: 0, filtersUpdated : true});
    this.setState(curFilters, () => {
      this.getUsersService();
    });
  }

  getCurFilters = () => {
    let curFilters = [];
    curFilters = this.state.curFilters;
  
    curFilters.key        = (this.state.key !== undefined) ? this.state.key : '';
    curFilters.type       = this.props.type;
    curFilters.subnetId   = (this.props.subnetId !== undefined) ? this.props.subnetId : '';
    curFilters.locationId = (this.props.locationId !== undefined) ? this.props.locationId : '';
    curFilters.useCaseId  = (this.props.useCaseId !== undefined) ? this.props.useCaseId : '';
    curFilters.domains  = (this.props.website !== undefined) ? [this.props.website] : '';
  
    curFilters.tagId      = (this.props.tagId !== undefined) ? this.props.tagId : '';
    curFilters.statuses   = (this.state.status !== undefined) ? this.state.status : [];
    curFilters.productTypes = (this.state.productTypes !== undefined) ? this.state.productTypes : [];
    curFilters.accountTypes = (this.state.accountTypes !== undefined) ? this.state.accountTypes : [];
    curFilters.sources      = (this.state.sources !== undefined) ? this.state.sources : [];

    if (this.state.domains !== undefined && this.state.domains.length > 0) {
      curFilters.domains      = (this.state.domains !== undefined) ? this.state.domains : [];
    }

    curFilters.verificationStatus   = (this.state.verificationStatus !== undefined) ? this.state.verificationStatus : [];
    curFilters.onboardingStatus   = (this.state.onboardingStatus !== undefined) ? this.state.onboardingStatus : [];
    curFilters.signup       = this.state.signup;
    curFilters.lead_scores  = this.state.lead_scores; 
    curFilters.lead_stages  = this.state.lead_stages;
    curFilters.account_managers  = this.state.account_managers;
    curFilters.use_cases    = this.state.use_cases;
    curFilters.bandwidth    = this.state.bandwidth;
    curFilters.credits      = this.state.credits;
    curFilters.proxies      = this.state.proxies;
    curFilters.tags         = this.state.tags;

    return curFilters;
  }

  getUsersServicePagination = () => {
    let params = userAction.toQueryString({
      filters : this.getCurFilters(),
      pagination: this.state.userPagination,
      getTotal: true,
      filtersUpdated: false
    });

    client(`users.php?${params}`).then(
      response => {
        this.setState({records: response.total});
    });
  }

  getUsersService = () => {
    let params = userAction.toQueryString({
      filters : this.getCurFilters(),
      pagination: this.state.userPagination
    });

    this.setState({loading: true});

    client(`users.php?${params}`).then(
      response => {
        this.setState({
          isOpen: false,
          loading: false,
          items : response.data,
          usersData: response.data,
          // records: response.total
        }, () => {
          if ((this.state.userPagination.pageSize >= this.state.items.length) && this.state.filtersUpdated) {
            this.getUsersServicePagination();
          }
        });
      },
      error => {
        console.error(error);
      },
    );
  }

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  submit = () => {
    let errors = [];

    if (this.state.formValues.first_name === undefined || !validate.name(this.state.formValues.first_name) || !validate.required(this.state.formValues.first_name)) {
      errors.push('Please enter a valid first name.');
    }

    if (this.state.formValues.last_name === undefined || !validate.name(this.state.formValues.last_name) || !validate.required(this.state.formValues.last_name)) {
      errors.push('Please enter a valid last name.');
    }

    if (this.state.formValues.email === undefined || !validate.email(this.state.formValues.email) || !validate.required(this.state.formValues.email)) {
      errors.push('Please enter a valid email address.');
    }

    if (errors.length > 0) {
      this.setState({
        show: true,
        errors: errors,
        success: ""
      });
    } else {
      this.saveUser();
    }
  }

  saveUser = () => {
    let method = "PUT";

    if (this.state.editable !== undefined && this.state.editable.customerId !== undefined) {
      method = "POST";
    }

    client(`user_signup.php`, {
      method: method,
      body: this.state.formValues,
    }).then(
      (response) => {

        if (response._user_message_type !== undefined && response._user_message_type === 'error') {
          this.setState({
            show: true,
            errors: [response._user_message],
            success: ''
          });
        } else if (response._user_message_type !== undefined && response._user_message_type === 'success') {
          this.setState({
            show: true,
            errors: [],
            success: response._user_message,
          });
          this.getUsersService();
          this.toggleAddNewUser();
        }
      },
      (error) => {
        if (error._user_message !== undefined) {
          error = error._user_message;
        }
  
        this.setState({
          show: true,
          errors: error,
          success: ''
        });
      }
    );
  };

  componentDidMount() {
    this.inputRef = React.createRef();
    this.getUserTags();
    this.getUsage();
    this.getLeadScores();
    this.getLeadStages();
    this.getTeam();
  }

  getUserTags = () => {
    users.getUserTags().then(userTags => this.setState({userTags}));
  }

  getTeam = () => {
    client(`admin/team`).then(
      (response) => {
        let account_managers_suggestions = [];

        response.forEach((accountManager) => {
          account_managers_suggestions.push({
            slug: accountManager.aid,
            name: accountManager.name,
          });
        });

        this.setState({ account_managers_suggestions });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getLeadStages = () => {
    users.getLeadStages().then((leadStages) => {
      let lead_stages_suggestions = [];

      leadStages.forEach(leadStage => {
        lead_stages_suggestions.push({slug: leadStage.value, name: leadStage.label}); 
      });

      this.setState({ lead_stages_suggestions });
    });
  };

  getLeadScores = () => {
    client(`leadScores.php`).then(
      (leadScores) => {
        let lead_scores = [];
  
        leadScores.forEach(leadScore => {
          lead_scores.push({slug: leadScore.lead_score, name: leadScore.lead_score}); 
        });

        this.setState({lead_scores_suggestions: lead_scores});
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getUsage = () => {
    client(`proxy_usage.php`).then(
      (usages) => {
        let use_cases = [];
  
        usages.data.forEach(useCase => {
            use_cases.push({slug: useCase.slug, name: useCase.name}); 
        });

        this.setState({use_cases_suggestions: use_cases});
      },
      (error) => {
        console.error(error);
      }
    );
  };

  onDelete(i) {
    const use_cases = this.state.use_cases.slice(0);
    use_cases.splice(i, 1);
    this.setState({ use_cases }, () => {
      this.getUsersService();
    });
  }

  onAddition(tag) {
    let useCase = this.state.use_cases_suggestions.filter(obj => obj.name === tag.name);

    if (useCase.length > 0) {
      const use_cases = [].concat(this.state.use_cases, useCase.shift());

      this.setState({ use_cases }, () => {
        this.getUsersService();
      });
    }
  }

  onDeleteLeadScore(i) {
    const lead_scores = this.state.lead_scores.slice(0);
    lead_scores.splice(i, 1);
    this.setState({ lead_scores }, () => {
      this.getUsersService();
    });
  }

  onAdditionLeadScore(tag) {
    let temp = this.state.lead_scores_suggestions.filter(obj => obj.name === tag.name);

    if (temp.length > 0) {
      const lead_scores = [].concat(this.state.lead_scores, temp.shift());
      this.setState({ lead_scores }, () => {
        this.getUsersService();
      });
    }
  }

  onDeleteLeadStage(i) {
    const lead_stages = this.state.lead_stages.slice(0);
    lead_stages.splice(i, 1);
    this.setState({ lead_stages }, () => {
      this.getUsersService();
    });
  }

  onAdditionLeadStage(tag) {
    let temp = this.state.lead_stages_suggestions.filter(obj => obj.name === tag.name);

    if (temp.length > 0) {
      const lead_stages = [].concat(this.state.lead_stages, temp.shift());
      this.setState({ lead_stages }, () => {
        this.getUsersService();
      });
    }
  }

  onAdditionUserTag(tag) {
    let temp = this.state.userTags.filter(obj => obj.name === tag.name);

    if (temp.length > 0) {
      const tags = [].concat(this.state.tags, temp.shift());
      this.setState({ tags }, () => {
        this.getUsersService();
      });
    }
  }

  onDeleteUserTag(i) {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ tags }, () => {
      this.getUsersService();
    });
  }

  onDeleteAccountManager(i) {
    const account_managers = this.state.account_managers.slice(0);
    account_managers.splice(i, 1);
    this.setState({ account_managers }, () => {
      this.getUsersService();
    });
  }

  onAdditionAccountManager(tag) {
    let temp = this.state.account_managers_suggestions.filter(obj => obj.name === tag.name);

    if (temp.length > 0) {
      const account_managers = [].concat(this.state.account_managers, temp.shift());
      this.setState({ account_managers }, () => {
        this.getUsersService();
      });
    }
  }

  printLoader = () => {
    return (<React.Fragment>
      {(!this.state.loading) ? (this.state.items.length === 0 ? 'No record found.' : '') : 'Loading' }
    </React.Fragment>);
  }

  updateUserTags = (user) => {
    users.setUserTags(user.customerId, user.tags).then(res => this.getUserTags());
  }

  toggleCell = (id, key, value) => {
    let items = this.state.items;

    items.map((user) => {
      if (user.customerId === id) {
        user[key] = value;
      }

      return user;
    });

    this.setState({items});
  }

  printRecords = () => {
    return (<React.Fragment>
      {this.state.items.map(data => (
        <tr key={data.customerId}>
          {this.props.page !== 'Dashboard' ? 
          <td>
            <input
              key={data.customerId}
              onChange={this.handleCheckChieldElement}
              type="checkbox"
              checked={data.isChecked}
              value={data.customerId}
            />
          </td>
          : "" }
          <td>
            <p >
              # {data.customerId}
              <br />
              {data.name}
            </p>
            <p ><small>{data.company_name}</small></p>
            <p className="profile__contact">
              {
                data.email_verified === 1 ||
                data.email_verified === "true" ||
                data.email_verified === true ? (
                  <React.Fragment>
                    <ShieldCheckIcon size={20} color="#66d568" id="userEmail" />
                    <UncontrolledTooltip placement="top" target="userEmail">
                      Account is admin verified.
                    </UncontrolledTooltip>
                  </React.Fragment>
                ) : (
                  ""
                )
              }
              <small>{data.email}</small>
            </p>
            <p className="profile__contact">
              {data.sms_verified === 1 ||
              data.sms_verified === "true" ||
              data.sms_verified === true ? (
                <React.Fragment>
                  <ShieldCheckIcon size={20} color="#66d568" id="userphoneNumber" />
                  <UncontrolledTooltip placement="top" target="userphoneNumber">
                    Phone number is verified!
                  </UncontrolledTooltip>
                </React.Fragment>
              ) : (
                ""
              )}
              <small>{data.phone}</small>
            </p>
            <p>
              {data.lead !== '' && data.lead !== null ? 
                <React.Fragment>
                  <strong>Lead Score</strong>&nbsp;:&nbsp;<small>{data.lead}</small>
                  <br />
                </React.Fragment>
               : "" }
               {data.source !== '' && data.source !== null ? 
                <React.Fragment>
                  <strong>Source</strong>&nbsp;:&nbsp;<small>{data.source}</small>
                  <br />
                </React.Fragment>
               : "" }
            </p>
            <UserTags tags={this.state.userTags} key={data.customerId} user={data} toggleCell={this.toggleCell} updateUser={this.updateUserTags} />
            {data.comments != undefined && data.comments != '' && data.comments.trim() != '' && <div className="notes"><i>&ldquo;{data.comments}&rdquo;</i></div>}
          </td>
          <td>
            {data.last_login !== '' && data.last_login !== null ? 
              <React.Fragment>
                <br />
                <strong>Last Login&nbsp;:&nbsp;</strong>
                <small>{TimeSince(data.last_login)}</small>
              </React.Fragment>
              : "" }
            
            {data.registered !== '' && data.registered !== null ? 
              <React.Fragment>
                <br />
                <strong>Since&nbsp;:&nbsp;</strong>
                <small>{TimeSince(data.registered)}</small>
              </React.Fragment>
              : "" }

            {data.traffic !== '' && data.traffic !== null ? 
              <React.Fragment>
                <br />
                <strong>Bandwidth Used&nbsp;:&nbsp;</strong>
                <small>{data.traffic}</small>
              </React.Fragment>
              : "" }
            
            {data.credit !== '' && data.credit !== null ? 
              <React.Fragment>
                <br />
                <strong>Credit&nbsp;:&nbsp;</strong>
                <small className={data.credit >= 0 ? "primaryText" : "dangerText"}>
                  <CurrencyFormat
                    value={data.credit}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </small>
              </React.Fragment>
              : "" }
          </td>
          <td>
            {data.traffic_type !== '' && data.traffic_type !== null ? 
              <React.Fragment>
                <strong>Use Case&nbsp;:&nbsp;</strong>
                <br /><small>{data.traffic_type}</small>
                <br />
                <br />
              </React.Fragment>
               : ''}
            <Suspense fallback={<div>Loading...</div>}>
              <UserProducts id={data.customerId} />
            </Suspense>
            <Suspense fallback={<div>Loading...</div>}>
              <UserAuthorizedIps id={data.customerId} />
            </Suspense>
          </td>
          <td>
            {data.status === 'suspended' ? 
              <UserStatus user={data} key={data} status={data.status} /> : 
              <UserStatus user={data} key={data} status={data.status} />
            }
          </td>
          <td>
            <UserActions 
            onEditClicked={() => (this.toggleEdit(data))} 
            user={data} 
            remove={() => this.remove(data)} 
            suspend={() => this.suspend(data, true)} 
            unsuspend={() => this.suspend(data, false)} 
            verify={() => this.verify(data)} 
            sendSMS={() =>  this.toggleMessage(data, 'sms')} 
            sendEmail={() => this.toggleMessage(data, 'email')}
            />
          </td>
        </tr>
      ))}
    </React.Fragment>);
  }

  suspend = (user, suspend) => {
    users.suspend(user.customerId, suspend).then(response => {
      this.setState({startIndex: 0, filtersUpdated : true}, () => this.getUsersService());
    }, (error) => {
      this.setState({
        show: true,
        errors: error._user_message,
        success: "",
      });
    })
  }

  verify = (user) => {
    users.verify(user.customerId, true).then(response => {
      this.getUsersService();
    }, (error) => {
      this.setState({
        show: true,
        errors: error._user_message,
        success: "",
      });
    })
  }

  remove = (user) => {
    users.remove(user.customerId).then(response => {
      this.getUsersService();
    }, (error) => {
      this.setState({
        show: true,
        errors: error._user_message,
        success: "",
      });
    })
  }

  pagination = () => {
    return this.state.records > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.usersData} 
          records={this.state.records} 
          initialPage={this.state.userPagination.currentPage}
          onChangePage={(pagination) => this.onChangePage(pagination) }
          pageSize={env.RECORDS_PER_PAGE} 
        />
      </div>
    ) : (
      ""
    )
  }

  onChangePage = (pagination) => {
    if (pagination.currentPage !== this.state.userPagination.currentPage) {
      this.setState({userPagination : pagination, filtersUpdated: false}, () => {
        this.getUsersService();
      });
    }
  }

  handleAllChecked = event => {
    let items = this.state.items;
    items.forEach(item => (item.isChecked = event.target.checked));
    this.setState({ items: items, checkedall: event.target.checked });
  };

  handleCheckChieldElement = event => {
    let items = this.state.items;
    items.forEach(item => {
      if (item.customerId == event.target.value) {
        item.isChecked = !item.isChecked;
      }
    });

    let checkedall = (items.filter(item => item.isChecked === false).length > 0) ? false: true;

    this.setState({ items: items, checkedall: checkedall });
  };
  
  triggerAction = (action) => {

    let ids = this.state.items
      .filter(item => item.isChecked === true)
      .map((item, index) => item = item.customerId);

    let params = userAction.toQueryString({
      filters : this.getCurFilters(),
      pagination: this.state.userPagination
    });

    if (action === 'addTags' && (this.state.formValues.tags === undefined || this.state.formValues.tags.length === 0)) {
      this.setState({
        show: true,
        errors: ['Please select at least one list'],
        success: '',
      });
    } else {
      users.bulkAction(action, params, {ids: ids, formValues: this.state.formValues}).then(response => {
        this.setState({
          show: true,
          isOpenTags: false,
          errors: [],
          success: 'User(s) has been added to list(s) successfully.',
        }, () => this.getUsersService());
      });
    }
  
    
  }

  onSelect(selectedList, selectedItem) {
  }

  onRemove(selectedList, removedItem) {
  }

  render() {
    return (
      <Container>
        <Row className="user-section">
         <UsersFilter onFilterClicked={this.filterUsers} type={this.props.type} page={this.props.page} verificationStatus={this.props.verificationStatus} />
          
          <Card className="table-section">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.props.title}</h5>
                {this.props.page !== 'Dashboard'?
                  <React.Fragment>
                    <div className="toolbar-buttons">
                      {this.state.items.filter(item => item.isChecked === true).length > 0 
                      ? <AdditionalTools triggerAction={this.triggerAction} addTags={this.addTags}  />
                      : <React.Fragment></React.Fragment>}
                      
                      <button type="button" onClick={() => {
                        this.setState({formValues: []}, () => this.toggleAddNewUser())
                      }} className="btn btn-sm btn-primary">Add user</button>
                    </div>
                  </React.Fragment>
                : '' }
              </div>
              {this.props.page !== 'Dashboard' 
                ? 
                <React.Fragment>
                  {/* <Row>
                    <Col md={6} lg={3} xl={3}>
                    <Multiselect
                      options={this.state.options} // Options to display in the dropdown
                      selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                      onSelect={this.onSelect} // Function will trigger on select event
                      onRemove={this.onRemove} // Function will trigger on remove event
                      displayValue="name" // Property name to display in the dropdown options
                      />
                    </Col>
                  </Row> */}
                  <Row>
                    <Col md={6} lg={3} xl={3}>
                      <div className="form profile-audit-log">
                        <div className="form__form-group search-bar">
                          <div className="form__form-group-field">
                            <ReactTags
                              ref={this.inputRef}
                              tags={this.state.use_cases}
                              allowNew={true}
                              suggestions={this.state.use_cases_suggestions}
                              onDelete={this.onDelete.bind(this)}
                              onAddition={this.onAddition.bind(this)}
                              placeholderText="Use Case" 
                              addOnBlur={true} 
                              />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} lg={3} xl={3}>
                      <div className="form profile-audit-log">
                        <div className="form__form-group search-bar">
                          <div className="form__form-group-field">
                            <ReactTags
                              ref={this.inputRef}
                              tags={this.state.lead_scores}
                              allowNew={true}
                              suggestions={this.state.lead_scores_suggestions}
                              onDelete={this.onDeleteLeadScore.bind(this)}
                              onAddition={this.onAdditionLeadScore.bind(this)}
                              placeholderText="Lead score" 
                              addOnBlur={true} 
                              />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} lg={3} xl={3}>
                      <div className="form profile-audit-log">
                        <div className="form__form-group search-bar">
                          <div className="form__form-group-field">
                            <ReactTags
                              ref={this.inputRef}
                              tags={this.state.lead_stages}
                              allowNew={true}
                              suggestions={this.state.lead_stages_suggestions}
                              onDelete={this.onDeleteLeadStage.bind(this)}
                              onAddition={this.onAdditionLeadStage.bind(this)}
                              placeholderText="Lead stage" 
                              addOnBlur={true} 
                              />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={6} lg={3} xl={3}>
                      <div className="form profile-audit-log">
                        <div className="form__form-group search-bar">
                          <div className="form__form-group-field">
                            <ReactTags
                              ref={this.inputRef}
                              tags={this.state.account_managers}
                              allowNew={true}
                              suggestions={this.state.account_managers_suggestions}
                              onDelete={this.onDeleteAccountManager.bind(this)}
                              onAddition={this.onAdditionAccountManager.bind(this)}
                              placeholderText="Account Manager" 
                              addOnBlur={true} 
                              />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} lg={12} xl={12}>
                      <div className="form profile-audit-log">
                        <div className="form__form-group search-bar">
                          <div className="form__form-group-field">
                            <ReactTags
                              ref={this.inputRef}
                              tags={this.state.tags}
                              allowNew={true}
                              suggestions={this.state.userTags}
                              onDelete={this.onDeleteUserTag.bind(this)}
                              onAddition={this.onAdditionUserTag.bind(this)}
                              placeholderText="Filter by List" 
                              addOnBlur={true} 
                              />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
                : ''}
              
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                  {this.props.page !== 'Dashboard' ? 
                    <th>
                      <input type="checkbox" checked={this.state.checkedall}  onChange={this.handleAllChecked} value="checkedall" />
                    </th>
                    : <React.Fragment></React.Fragment>}
                    {this.state.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
                  </tr>
                </thead>
                <tbody>
                  {this.printRecords()}
                </tbody>
              </Table>
              {this.pagination()}
              {this.printLoader()}
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.submit()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.toggleAddNewUser()}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <FormComponent  
            title={(this.state.editable !== undefined && this.state.editable.customerId !== undefined) ? 'Edit User': 'Add New User'}
            toggleAddNewUser={this.toggleAddNewUser} 
            handleForm={(formValues) => this.handleForm(formValues)} 
            edit={() => {
              return this.state.editable;
            }} />
        </Slider>

        
        <Slider
          isOpen={this.state.isOpenTags}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.triggerAction('addTags')} type="button">Save</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.setState({ isOpenTags: false })}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpenTags: false })}
        >
          <AddTags  
            title={'Add to Lists'}
            suggestions={this.state.userTags} 
            handleForm={(formValues) => this.handleForm(formValues)} 
            />
        </Slider>

        <Slider
          isOpen={this.state.isOpenAlert}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.sendMessage()} type="button">Send</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.setState({ isOpenAlert: false })}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpenAlert: false })}
        >
          <SendMessageForm  
            title={this.state.isOpenAlertType === 'sms' ? 'Send SMS' : 'Send Email'}
            toggleAddNewUser={this.toggleAddNewUser} 
            handleForm={(formValues) => this.handleForm(formValues)} 
            edit={() => {
              return this.state.editable;
            }} />
        </Slider>

        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}

export default UsersCommon;
